const actionTypes = {
  RECEIVE_USER: "seneca/users/RECEIVE_USER",
  RECEIVE_USERS: "seneca/users/RECEIVE_USERS"
};

export default actionTypes;
